module.exports = __webpack_public_path__ + "img/map-256.bc7ad628.png";